import styled from 'styled-components'

const Text = styled.span`
  padding-left: 0.5rem;
  pointer-events: none;
`

export default Text;
